import React from "react";

const Download = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      style={style}
      stroke="currentColor"
    >
      <g id="Raggruppa_587" transform="translate(-1428 -590)">
        <g id="Raggruppa_585" transform="translate(1432 595.161)">
          <path
            id="Tracciato_117"
            d="M25.75,15v5.056a2.527,2.527,0,0,1-2.528,2.528H5.528A2.527,2.527,0,0,1,3,20.056V15"
            transform="translate(-3 -0.328)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            id="Tracciato_118"
            d="M7,10l6.319,6.319L19.639,10"
            transform="translate(-1.943 -1.647)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <line
            id="Linea_147"
            y1="15"
            transform="translate(11.376 -1.161)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
};

export default Download;
